import { DropdownMenuContent as UiKitDropdownMenuContent } from "ics-ui-kit/components/dropdown";
import { type FC, forwardRef } from "react";
import type { ExtractComponentGeneric } from "../../lib/extractComponentGeneric";
import { VIEWPORT_PADDING } from "../../lib/floating";
import { useDropdownMenuAnchoredPopoverContext } from "./DropdownMenuAnchoredPopover";

interface UiKitDropdownMenuContentProps extends ExtractComponentGeneric<typeof UiKitDropdownMenuContent> {}

export const DropdownMenuContent: FC<UiKitDropdownMenuContentProps> = forwardRef(
	({ collisionPadding = VIEWPORT_PADDING, onInteractOutside, ...props }, ref) => {
		const anchoredPopover = useDropdownMenuAnchoredPopoverContext();

		return (
			<UiKitDropdownMenuContent
				collisionPadding={collisionPadding}
				onInteractOutside={(event) => {
					if (anchoredPopover?.containsTarget(event.target)) event.preventDefault();
					onInteractOutside?.(event);
				}}
				ref={ref}
				{...props}
				data-dropdown-menu-content
				data-qa="dropdown-content"
				data-testid="dropdown-content"
			/>
		);
	},
);
